
import { Component, Vue } from "nuxt-property-decorator";
import OilImportTable from "~/components/organisms/table/OilImportTable.vue";
import ContentPageLayout from "~/components/molecules/display/ContentPageLayout.vue";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import type { JumpNavItem } from "~/types/ContentPage";

@Component({
  scrollToTop: true,
  components: {
    ContentPageLayout,
    OilImportTable,
  },
})
export default class HeizwertPellets extends Vue {
  head() {
    return {
      ...generateMetaTags(this.$route.path, "heizwert-pellets"),
      link: [{ rel: "canonical", href: this.$route.path }],
    };
  }

  get jumpNavItems(): JumpNavItem[] {
    return [
      {
        name: "Was ist der Heizwert Pellets?",
        title: "Springen Sie zum Bereich für Infos zu: Heizwert – Definition",
        href: {
          hash: "#first-anker",
        },
      },
      {
        name: "Pellets im Vergleich zu anderen Brennstoffen",
        title:
          "Springen Sie zum Bereich für Infos zu: Vergleich der Brennstoffe",
        href: {
          hash: "#second-anker",
        },
      },
      {
        name: "Heizwert vs. Brennwert",
        title: "Springen Sie zum Bereich für Infos zu: Heizwert vs. Brennwert",
        href: {
          hash: "#third-anker",
        },
      },
      {
        name: "Was beeinflusst den Heizwert Pellets?",
        title: "Springen Sie zum Bereich für Infos zu: Einflussfaktoren",
        href: {
          hash: "#fourth-anker",
        },
      },
      {
        name: "Bedeutung des Heizwert Pellets für Hausbesitzer",
        title:
          "Springen Sie zum Bereich für Infos zu: Bedeutung für Hausbesitzer",
        href: {
          hash: "#fifth-anker",
        },
      },
      {
        name: "Pelletverbrauch mit dem Heizwert Pellets berechnen",
        title: "Springen Sie zum Bereich für Infos zu: Verbrauch & Lagerraum",
        href: {
          hash: "#sixth-anker",
        },
      },
      {
        name: "FAQ & Praxiswerte",
        title: "Springen Sie zum Bereich für Infos zu: FAQ & Praxiswerte",
        href: {
          hash: "#seventh-anker",
        },
      },
      {
        name: "Optimale Werte",
        title: "Springen Sie zum Bereich für Infos zu: Optimaler Heizwert",
        href: {
          hash: "#eighth-anker",
        },
      },
    ];
  }
}
